import CryptoJS from '../../node_modules/crypto-js/crypto-js.js';



class CommonApi{

	static Encrypt (word, aesKey) {
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  const data2 = CryptoJS.AES.encrypt(JSON.stringify(word), key, {
    iv: CryptoJS.enc.Utf8.parse(aesKey.substr(0, 16)),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return data2.toString();
};
	static Decrypt (word, aesKey) {
		const key = CryptoJS.enc.Utf8.parse(aesKey);
		const decrypt = CryptoJS.AES.decrypt(word, key, {
			iv: CryptoJS.enc.Utf8.parse(aesKey.substr(0, 16)),
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		const decryptedStr = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
		return decryptedStr;
	}

	static orders(id) {
		// console.log("id",id)
		const root = process.env.API_HOST
		const timestamp = Date.now();
		const md5 = CryptoJS.MD5("NkKsiSkw069c" + '%*$4r6h(K))2d*qcast*7j55f21!*&4MY^$' + timestamp).toString();
		// console.log("md5",md5);
			const data = {
				func:"orders",
				vendor: "wechat",
				market_code: 8,
				account_id: id,
				timestamp,
				sign: md5
			};
			const data2 = CommonApi.Encrypt(data, '$3r6h(K)2d7j21!^');
			const data3 = encodeURIComponent(data2);
			const url = `${root}?data=${data3}`.replace(/\s*/g, "");
			return url
	}

	static login(id) {
		// console.log("id",id)
		const root = process.env.API_HOST
		console.log(root);
		const timestamp = Date.now();
		const md5 = CryptoJS.MD5("NkKsiSkw069c" + '%*$4r6h(K))2d*qcast*7j55f21!*&4MY^$' + timestamp).toString();
		// console.log("md5",md5);
			const data = {
				func:"login",
				vendor: "wechat",
				market_code: 8,
				account_id: id,
				timestamp,
				sign: md5
			};
			const data2 = CommonApi.Encrypt(data, '$3r6h(K)2d7j21!^');
			const data3 = encodeURIComponent(data2);
			const url = `${root}?data=${data3}`.replace(/\s*/g, "");
			return url
	}

	static medal(id) {
		// console.log("id",id)
		const root = process.env.API_HOST
		console.log(root);
		const timestamp = Date.now();
		const md5 = CryptoJS.MD5("NkKsiSkw069c" + '%*$4r6h(K))2d*qcast*7j55f21!*&4MY^$' + timestamp).toString();
		// console.log("md5",md5);
			const data = {
				func:"pets",
				vendor: "wechat",
				market_code: 8,
				account_id: id,
				timestamp,
				sign: md5,
				action:"list"
			};
			const data2 = CommonApi.Encrypt(data, '$3r6h(K)2d7j21!^');
			const data3 = encodeURIComponent(data2);
			const url = `${root}?data=${data3}`.replace(/\s*/g, "");
			return url
	}
	
}

export default CommonApi


// WEBPACK FOOTER //
// ./src/commonData/commonApi.js